import { render, staticRenderFns } from "./JobsTable.vue?vue&type=template&id=38727210"
import script from "./JobsTable.vue?vue&type=script&lang=ts"
export * from "./JobsTable.vue?vue&type=script&lang=ts"
import style0 from "./JobsTable.vue?vue&type=style&index=0&id=38727210&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports